module.exports = new __parcel__URL__("inline-column-create-dark.7d2ee1ec.png").toString();